import { make } from 'vuex-pathify'
import state from './state'

export default {
  ...make.getters(state),

  isAdmin: state => {
    return state.user.email === 'pongsakorn.onsri@gmail.com'
  }
}
